<div *ngIf="selectForm" class="select-search" [formGroup]="selectForm">
  <div
    class="select-search__element select-search__element__grid"
    [class.select-search__element--modal]="modalOpen"
    appDropdownPanel
  >
    <mat-icon
      *ngIf="!modalOpen && (isMobile$ | async) === false"
      class="select-search__icon"
      [class]="field?.iconClass"
      [style.-ms-grid-column]="1"
      matSuffix
      [svgIcon]="field.icon"
      role="presentation"
    ></mat-icon>

    <mat-form-field
      class="dropdown dropdown--filter dropdown-left-0 select-search__field"
      [style.-ms-grid-column]="2"
      [class.dropdown--simple]="!modalOpen"
      floatLabel="never"
      [attr.dropdownOpen]="select.panelOpen"
      [attr.dropdownSelected]="!!select?.value"
      appearance="legacy"
    >
      <mat-label class="select-search__label" [class.select-search__label--advanced]="!isInMainFields">{{
        field.placeholder
      }}</mat-label>
      <mat-select
        role="listbox"
        [formControlName]="field.name"
        panelClass="dropdown-panel dropdown-panel-search dropdown-worktime"
        #select="matSelect"
        [aria-label]="field.ariaLabel"
        (openedChange)="isPanelOpen.emit($event)"
      >
        <mat-option
          role="option"
          *ngFor="let value of field.value; trackBy: trackBySelectSearchValue"
          [value]="value.paramValue"
          [attr.aria-label]="value.name"
          >{{ value.name }}</mat-option
        >
      </mat-select>
      <mat-icon *ngIf="!select?.value" matSuffix svgIcon="arrow_next" role="presentation"></mat-icon>
      <button
        type="button"
        class="delete-btn btn-clean"
        matSuffix
        [attr.aria-label]="'Suppression du filtre ' + field.ariaLabel | lowercase | upperfirst"
        class="select-search__button-delete delete-btn btn-clean"
        *ngIf="!!select?.value"
        (click)="clearValue($event)"
      >
        <mat-icon svgIcon="cross" role="presentation"></mat-icon>
      </button>
    </mat-form-field>
  </div>
</div>
